import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';

import { Card } from 'components/Card';
import Message from 'components/Message';
import { bem } from 'helpers/class-name';
import { useIsServicePricingProofEnabled } from 'hooks/useIsServicePricingProofEnabled';

import ServicesContext from '../ServicesContext';
import EmptyList from '../../EmptyList';
import messages from '../../ManageServices.messages';
import { messages as servicesMessages } from '../Services.messages';
import ServicesListItem from './ServicesListItemContainer';

import './ServicesList.scss';

const { block, element } = bem('services-list');
const blockClasses = block('mb-0');

function ServicesList({ showPricingColumns: showPricingColumnsProp }) {
  const { servicesWithPrice, isLoading } = useContext(ServicesContext);
  const isPricingProofEnabled = useIsServicePricingProofEnabled();
  const showPricingColumns = showPricingColumnsProp ?? isPricingProofEnabled === true;

  if (isLoading || _isEmpty(servicesWithPrice)) {
    return (
      <Card className={blockClasses} loading={isLoading} centered>
        <EmptyList
          header={messages.empty.servicesHeader}
          text={messages.empty.servicesText}
          button={messages.addBtn.service}
        />
      </Card>
    );
  }

  return (
    <Card className={blockClasses} flush>
      {showPricingColumns && (
        <div className={element('header')}>
          <div className={element('header-name')}>
            <Message
              as="div"
              className="pt-regular pb-regular pl-large text--medium"
              message={servicesMessages.list.name}
            />
          </div>
          <div className={element('header-bookable', 'pr-large')}>
            <Message as="div" className="pt-regular pb-regular text--medium" message={servicesMessages.list.bookable} />
          </div>
        </div>
      )}
      <ul className="roster__list">
        {servicesWithPrice.map(service => (
          <ServicesListItem key={service.id} {...service} showPricingColumns={showPricingColumns} />
        ))}
      </ul>
    </Card>
  );
}

ServicesList.propTypes = {
  showPricingColumns: PropTypes.bool,
};

export default ServicesList;
